module.exports = __webpack_public_path__ + "static/img/khk-003b.c8a44f5a.jpg";